import { DEFAULT_TIMEOUT, type NotificationItemStored } from './notificationsStore.model';

export const useNotificationsStore = defineStore('notifications', () => {
  // State
  const notifications = ref<NotificationItemStored[]>([]);

  // Actions
  function add(notification: Omit<NotificationItemStored, 'id'>): NotificationItemStored['id'] {
    const newNotification: NotificationItemStored = {
      ...notification,
      id: crypto.randomUUID(),
    };

    notifications.value.push(newNotification);

    // timeout 0 = sticky: removed only by an action or the close icon.
    if (notification.timeout !== 0) {
      setTimeout(() => {
        remove(newNotification.id);
      }, notification.timeout || DEFAULT_TIMEOUT);
    }

    return newNotification.id;
  }

  function remove(id: string): void {
    notifications.value = notifications.value.filter(notification => notification.id !== id);
  }

  function clear(): void {
    notifications.value = [];
  }

  return {
    // State
    notifications: readonly(notifications),
    // Core actions
    add,
    remove,
    clear,
  };
});